<script>
    import Button from "@smui/button";
    import { onMount } from "svelte";
    import loading from "../../components/loading";
    import title from "../../components/title";
    import { post } from "../../http";
    import { getObject } from "../../session";

    export let location;

    let pickup = {};
    let paymentType = "";
    let hasRequest = false;
    let isLoading = false;

    function back() {
        const waNumber = sessionStorage.getItem("waNumber");
        window.open("https://wa.me/" + waNumber);
    }

    function next() {
        loading.show();
        post("/api/pickup", { data: pickup })
            .then((resp) => {
                if (resp.status == 0) hasRequest = true;
                sessionStorage.setItem("hasRequest", true);
            })
            .finally(() => loading.hide());
    }

    onMount(() => {
        title.set("Review Pickup");
        pickup = getObject("pickup");
        hasRequest = sessionStorage.getItem("hasRequest") == "true";
        console.log(pickup);
        paymentType = getObject("payment").name;
        loading.isLoading().subscribe((val) => (isLoading = val));
    });
</script>

<div class="content">
    <div>
        <div class="field_key">Waktu Pickup:</div>
        <div class="field_value">{pickup.pickup_time}</div>
    </div>
    <div>
        <div class="field_key">Alamat Pickup:</div>
        <div class="field_value">
            {pickup.pickup_name}
            ({pickup.pickup_phone})
        </div>
        <div class="field_value">{pickup.pickup_address}</div>
        <div class="field_value">
            {pickup.pickup_district},
            {pickup.pickup_city},
            {pickup.pickup_province},
            {pickup.pickup_zipcode}
        </div>
    </div>
    <div>
        <div class="field_key">Total Pembayaran:</div>
        <div class="field_value">Rp.{pickup.amount}</div>
    </div>
    <div>
        <div class="field_key">Metode Pembayaran:</div>
        <div class="field_value">{paymentType}</div>
    </div>
    <div class="text-right">
        {#if hasRequest}
            <Button variant="unelevated" on:click={back} disabled={isLoading}>
                Lanjutkan Pembayaran via WA
            </Button>
        {:else}
            <Button variant="unelevated" on:click={next} disabled={isLoading}>
                Lanjutkan
            </Button>
        {/if}
    </div>
</div>

<style lang="scss">
    .field_key {
        font-weight: 600;
    }
    .field_value {
        margin-left: 16px;
        // font-size: 0.9em;
    }
</style>
